import { FC } from 'react';
import { Badge, Typography } from '../../../ui';
import { Divider } from '../../../atoms/divider/divider';

type Props = {
  team: string;
  date: string;
};

export const ChangedTeamDivider: FC<Props> = (props) => {
  const { team, date } = props;

  return (
    <Divider>
      <div className="flex items-center space-x-8">
        <Typography
          variant="body-xs"
          weight="regular"
          className="text-grayscale400 text-nowrap"
        >
          Toegewezen aan
        </Typography>
        <Badge label={team} />
        <Typography
          variant="body-xxs"
          weight="regular"
          className="text-grayscale300 text-nowrap"
        >
          {date}
        </Typography>
      </div>
    </Divider>
  );
};
